const toast_config = {
	position: "top-right",
	autoClose: 3000,
	hideProgressBar: true,
	newestOnTop: false,
	rtl: false,
	theme: "colored",
	limit: 1
};

export {toast_config};

export const platformLayout = {
	Platform : "Platform",
	Organization : "Organization",
	Patient : "Patient"
};

export const ActivityDetails = {
	ApplicationStarted: { event: "Application Started", details: "Application Started" },
	ApplicationUpdates: { event: "Application Updates", details: "Application Updates" },
	MetaDataUpdate: { event: "Meta Data Update", details: "Meta Data Update" },
	NotesAdded: { event: "Notes Added", details: "Notes Added" },
	AdminAssignment: { event: "Admin Assignment", details: "Admin Assignment" },
	StageUpdate: { event: "Stage Update", details: "Stage Update" },
	DocumentUploadDownload: { event: "Document Upload/Download", details: "Document Upload/Download" },
	DocumentExpired: { event: "Document Expired", details: "Document Expired" },
	ApplicationArchived: { event: "Application Archived", details: "Application Archived" },
	ApplicationSigned: { event: "Application Signed", details: "Application Signed" },
	MedicaidEnrollmentStatusUpdate: { event: "Medicaid Enrollment Status Update", details: "Medicaid Enrollment Status Update" },
	DenialReasonCodeUpdate: { event: "Denial Reason Code Update", details: "Denial Reason Code Update" },
	DenialReasonNoteUpdate: { event: "Denial Reason Note Update", details: "Denial Reason Note Update" },
	FormAddEditUpdate: { event: "Form Add/Edit/Update", details: "Form Add/Edit/Update" },
	NoticeUploadDownload: { event: "Notice Upload/Download", details: "Notice Upload/Download" },
	TaskCreationUpdate: { event: "Task Creation/Update", details: "Task Creation/Update" },
	TextSMSMMSCorrespondence: { event: "Text/SMS/MMS Correspondence", details: "Text/SMS/MMS Correspondence" }
};


export const ITEMS_PER_PAGE = 10;

export const AI_CARE = "Medicaid Eligibility";
